<script lang="ts">
	export let fluid = false;
	export let center = false;
	export let style = '';
</script>

<div class:fluid class:center {style}>
	<slot />
</div>

<style>
	div {
		padding: 1rem;
		margin: 0 auto;
		max-width: 1200px;
	}

	.fluid {
		max-width: unset;
	}

	.center {
		text-align: center;
	}
</style>
